export default "__VITE_ASSET__CaOzsckC__"